import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from "react-bootstrap";

import BaseActionForm from '../BaseActionForm';
import './styles.scss'
import LeftPanelHeader from './../../components/LeftPanelHeader';

import { prettyDateTime } from "../../utils/DateFunctions.js"
import { checkActiveProcess } from '../../utils/ProcessFunctions.js';
import * as actionTypes from "../../services/StoreContainer/actionTypes";

export default function Publisher(props) {
    const dispatch = useDispatch();
    const datasetsContainer = useSelector((store) => { return store.datasetsReducer })

    return <PublisherClass
        {...props}
        dispatch={dispatch}
        datasetsContainer={datasetsContainer}
    />
}
class PublisherClass extends BaseActionForm {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dataset: null,
            processResult: null
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        let dataset = this.props.datasetsContainer.selectedDataset;
        this.handleDatasetSelect(dataset)
    }

    handleDatasetSelect = (dataset) => {
        this.setState(
            {
                dataset: dataset
            }, () => {
                if (dataset) {
                    this.setState({ activeProcess: checkActiveProcess(dataset, 'lk_publisher') });
                }
            }
        );
    }

    onStartProcess = () => {
        if (this.state.dataset && !this.state.activeProcess) {
            this.lkApi.lKPublisherTask(this.state.dataset.dataset).then((response) => {
                this.setState({
                    activeProcess: true
                });
                setTimeout(() => {
                    this.setState({ activeProcess: checkActiveProcess(this.state.dataset, 'lk_publisher') });
                }, 5000);
            });
        }
    };

    render() {
        return (
            <div className='twoHalfs'>
                <div id={"exporter"} className={"flexColumn rightPanel"}>
                    {this.renderAlerts()}

                    <LeftPanelHeader
                        dataset={this.state.dataset}
                        sectionName={this.sectionName(actionTypes.PUBLISHER)}
                    />

                    {this.state.dataset &&
                        <div className="postHeaderContainer textRoboto infoContainer">
                            {(this.state.dataset.geoportalLayerId) &&
                                <div className='textBottom'>
                                    Уже было опубликовано{(this.state.dataset.publicate ? '(' + prettyDateTime(new Date(parseInt(this.state.dataset.publicate.time))) + ')' : "") + ", "}
                                    <a href={"https://rk.geosamara.ru/map/?defaultLayers=tms51_layer," + this.state.dataset.geoportalLayerId} target="_blank" rel="noreferrer">посмотреть на карте</a>
                                </div>
                            }
                            {!this.state.dataset.geoportalLayerId &&
                                <div className='textBottom'>
                                    Этот набор данных публикуется на карту впервые. Будет заведен новый слой.
                                </div>
                            }
                        </div>
                    }
                    {
                        (this.state.processResult)
                            ?
                            <div className='textBottom'>
                                {(this.state.processResult.status === "success")
                                    ?
                                    <div>
                                        <p className='textBottom'>Запущена публикация на карту</p>
                                    </div>
                                    :
                                    <p className='textBottom'>Произошла ошибка: {this.state.processResult.errorMessageRu}</p>
                                }
                            </div>
                            :
                            (this.state.dataset) &&
                            <Button className='applyInstrument' style={this.state.activeProcess ? { opacity: '0.3', pointerEvents: 'none' } : { opacity: '1' }} onClick={this.onStartProcess}>
                                {this.state.dataset.geoportalLayerId ? 'Повторить публикацию' : 'Запустить публикацию'}
                            </Button>
                    }
                    <p className={'infoProcesses textBottom'} style={this.state.activeProcess ? { display: 'inline' } : { display: 'none' }}> Дождитесь завершения запущеных процессов </p>

                </div>

                <div className='rightHalf'></div>

            </div>
        );
    }
}











